import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

import Login from '@v/Login'
import Logout from '@v/Logout'
import Home from '@v/Home'
import UsersList from '@v/users/List'
import UsersForm from '@v/users/Form'

import PluginsForm from '@v/plugins/Form'
import PluginsList from '@v/plugins/List'
import PluginsLibrary from '@v/plugins/Library'
import PluginsSuggest from '@v/plugins/Suggest'

import PapersIndex from '@v/papers/Index'
import Interlocutors from '@v/papers/Interlocutors'
import Bills from '@v/papers/Bills'
import Drc from '@v/papers/Drc'
import Error from '@v/Error'

import store from '@/stores/store.js'

import Utils from '@s/utils'
import {loadLanguage} from '@s/lang'

Vue.use(Router)

var router = new Router({
    routes: [
        /*------------------------------
         CONNEXION
         ------------------------------*/
        {
            path: '/login',
            name: 'Login',
            component: Login,
            meta: {
                requiresAuth: false
            }
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout,
            meta: {
                requiresAuth: true
            }
        },
        /*------------------------------

         ------------------------------*/
        {
            path: '/home',
            name: 'home',
            component: Home,
            meta: {
                requiresAuth: true,
                fallback: '/error'
            }
        },

        {
            path: '/users',
            name: 'usersList',
            component: UsersList,
            meta: {
                requiresAuth: true,
                fallback: '/error'
            },
            beforeEnter: (to, from, next) => {
                if (store.getters['Auth/permissions'].indexOf('admin-browse-users') == -1) {
                    next({name: 'bills'})
                } else {
                    next()
                }
            }
        },
        {
            path: '/users/new',
            name: 'usersFormNew',
            component: UsersForm,
            meta: {
                requiresAuth: true,
                fallback: '/users'
            }
        },
        {
            path: '/users/:id',
            name: 'usersForm',
            component: UsersForm,
            meta: {
                requiresAuth: true,
                fallback: '/users'
            }
        },
        {
            path: '/client',
            name: 'papersIndex',
            component: PapersIndex,
            meta: {
                requiresAuth: true,
                fallback: '/error'
            }
        },
        {
            path: '/client/interlocutors',
            name: 'interlocutors',
            component: Interlocutors,
            meta: {
                requiresAuth: true,
                fallback: '/client'
            }
        },
        {
            path: '/client/bills',
            name: 'bills',
            component: Bills,
            meta: {
                requiresAuth: true,
                fallback: '/client'
            }
        },
        {
            path: '/client/drc',
            name: 'drc',
            component: Drc,
            meta: {
                requiresAuth: true,
                fallback: '/client'
            }
        },
        {
            path: '/plugins/new/:id',
            name: 'pluginNew',
            component: PluginsForm,
            meta: {
                requiresAuth: true,
                fallback: '/plugins'
            }
        },
        {
            path: '/plugins/edit/:id',
            name: 'pluginEdit',
            component: PluginsForm,
            meta: {
                requiresAuth: true,
                fallback: '/plugins'
            }
        },
        {
            path: '/plugins/library/:id?',
            name: 'pluginsLibrary',
            component: PluginsLibrary,
            meta: {
                requiresAuth: true,
                fallback: '/plugins'
            }
        },
        {
            path: '/plugins/suggest',
            name: 'pluginsSuggest',
            component: PluginsSuggest,
            meta: {
                requiresAuth: true,
                fallback: '/plugins/library'
            }
        },
        {
            path: '/plugins',
            name: 'pluginsList',
            component: PluginsList,
            meta: {
                requiresAuth: true,
                fallback: '/plugins'
            }
        },

        {
            path: '/error',
            name: 'error',
            component: Error,
            meta: {
                requiresAuth: true,
            }
        },
        {
            path: '/',
            beforeEnter: (to, from, next) => {
                if (store.getters['Auth/permissions'].indexOf('admin-browse-users') == -1) {
                    next({name: 'bills'})
                } else {
                    next({name: 'usersList'})
                }
            }
        }
    ]
})

export default router;

router.routeCount = 0;

router.beforeEach((to, from, next) => {

    store.commit('UI/showNav', false);
    store.commit('UI/backAction', null);


    let promiseAutoLogin = null;

    if (!!to.query.lang && ['fr', 'en', 'it', 'es'].includes(to.query.lang)) {
        router.app.$localStorage.set("MANAGER_LOCALE", to.query.lang)
        loadLanguage(to.query.lang)
    }

    if (!!to.query.token) {
        router.app.$localStorage.set('ACCESS_TOKEN', to.query.token)
    }

    if (!!to.query.refresh) {
        router.app.$localStorage.set('REFRESH_TOKEN', to.query.refresh)
    }

    if (to.query.token != null) {

        if (to.query.idclient != null) {
            axios.defaults.headers.asClient = to.query.idclient;
        }

        promiseAutoLogin = store.dispatch('Auth/checkToken', to.query.token)
            .then(response => {
                if (to.query.lang)
                    next({...to, query: {...to.query, lang: undefined}})
                else next();
            })
    }

    if (to.query.nologout == 1) {
        sessionStorage.setItem('NO_LOGOUT', 1);
    }


    if (from.name == null) {
        if (to.query.from) {
            sessionStorage.setItem('ADMINV5_FROM', to.query.from);
        } else {
            sessionStorage.removeItem('ADMINV5_FROM');
        }
    }


    var LS = router.app.$localStorage;

    if (to.name != from.name) {
        store.commit('UI/showLoading', true);

    }


    if (promiseAutoLogin != null) {
        promiseAutoLogin.then(response => {
            next();
        })
    } else {


        setTimeout(function () {


            if (to.matched.some(record => record.meta.requiresAuth)) {


                if (!store.getters['Auth/isAuthenticated']) {
                    if (LS.get('ACCESS_TOKEN')) {
                        store.dispatch('Auth/checkToken', LS.get('ACCESS_TOKEN'))
                            .then(response => {
                                Utils.checkBills()
                                if (to.matched.some(record => record.name == 'Login')) {
                                    next('/');
                                } else {
                                    next();
                                }
                            })
                            .catch(e => {
                                store.commit('UI/loginError', "Vous n\'êtes pas autorisé à vous connecter à cette application");
                                store.commit('UI/showLoading', false);
                                next({
                                    path: '/login'
                                })
                            })

                    } else {
                        //window.Vfc.$refs.loading.hide();
                        var redirect = null;
                        if (to.name == "Logout") {
                            next({
                                path: '/login'
                            })
                        } else {
                            store.commit('UI/loginError', "Vous devez être connecté pour accéder à cette page.");
                            redirect = to.fullPath;
                            next({
                                path: '/login',
                                query: {redirect: redirect}
                            })
                        }


                    }


                } else {
                    window.V.loginMode = false;
                    if (to.matched.some(record => record.name == 'Login')) {
                        next('/');
                    } else {
                        next();
                    }
                }
            } else {
                if (to.matched.some(record => record.name == 'Login')) {

                    if (to.params.token != null) {
                        store.dispatch('Auth/checkToken', to.params.token)
                            .then(response => {
                                Utils.checkBills()
                                if (to.matched.some(record => record.name == 'Login')) {
                                    next('/');
                                } else {
                                    next();
                                }
                            })
                            .catch(e => {
                                store.commit('UI/loginError', "Vous n\'êtes pas autorisé à vous connecter à cette application");
                                store.commit('UI/showLoading', false);
                                next({
                                    path: '/login'
                                })
                            })

                    } else {
                        next();
                    }

                } else {
                    store.commit('UI/showLoading', false);
                    next();
                }

            }

            Utils.checkBills()

        }, 500)
    }
})

router.afterEach((to, from) => {
    router.routeCount++;
    store.dispatch('Messages/checkCountsForAutoDisappear')
});

/// Axios configuration

// Utils to handle multiples 401 request at the same time
let refreshTokenPromise = null
const clearPromise = () => {
    refreshTokenPromise = null
}

//Interceptors
axios.interceptors.request.use(function (config) {
    const token = store.getters['Auth/accessToken'] || localStorage.getItem('ACCESS_TOKEN')

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }

    // Do not add token for login endpoint to prevent error when login with outdated token
    if (config.url === 'users/login') {
        delete config.headers.Authorization
    }

    return config
}, function (error) {
    return Promise.reject(error)
})

axios.interceptors.response.use(
    function (response) {
        return response;
    },
    async function (error) {
        if (401 === error.response.status) {
            if (error.response && error.response.data && error.response.data.message == 'invalid_credentials') {
                store.commit('Messages/addError', "Vos identifiants et/ou mot de passe ne sont pas valides");
            } else {
                const prevRequest = error.config

                if (!prevRequest.sent) {
                    prevRequest.sent = true

                    // Si il n'y à pas d'appel de refresh token en cours, alors on génère une promise que l'on stock dans une variable globale de façon à ce que les possibles autres requêtes attendent la resolution de cette promise avant de s'effectuer
                    if (!refreshTokenPromise) {
                        refreshTokenPromise = store.dispatch('Auth/retryAuth').finally(clearPromise)
                    }

                    await refreshTokenPromise

                    return axios(prevRequest)
                } else {
                    store.commit('Messages/addError', "Vous avez été deconnecté. Merci de saisir vos identifiants.");
                    store.commit('Auth/logout');
                    window.V._router.push('/login');
                }
            }
            return Promise.reject(error);

        } else if (400 === error.response.status) {
            store.commit('Messages/addError', error.response.data.message);
            window.V._router.push(window.V._router.app._route.meta.fallback);
            return Promise.reject(error);
        } else if (404 === error.response.status) {
            store.commit('Messages/addError', window.V.$i18n.t('errors.e404'));
            window.V._router.push(window.V._router.app._route.meta.fallback);
            return Promise.reject(error);
        } else if (500 === error.response.status) {
            store.commit('Messages/addError', window.V.$i18n.t('errors.e500') + ' ' + error.response.data.message);
            window.V._router.push(window.V._router.app._route.meta.fallback);
            return Promise.reject(error);
        } else if (403 === error.response.status) {
            store.commit('Messages/addError', window.V.$i18n.t('errors.e403') + ' ' + error.response.data.message);
            window.V._router.push(window.V._router.app._route.meta.fallback);
            return Promise.reject(error);
        } else {
            return Promise.reject(error);
        }
    });




// WEBPACK FOOTER //
// ./src/router/index.js